import { useTranslation } from 'react-i18next';

import { Body1, Modal, Stack } from '@myphx-engineering/phx-design-system';

type NotCoveredModalProps = {
    opened: boolean;
    close: () => void;
};

export const NotCoveredModal = ({ opened, close }: NotCoveredModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={opened}
            onClose={close}
            title={t('common.drugCoverageAlerts.notCovered.modalTitle')}
        >
            <Stack gap="sm">
                <Body1>
                    {t(
                        'common.drugCoverageAlerts.notCovered.modalDescriptionOne'
                    )}
                </Body1>
                <Body1>
                    {t(
                        'common.drugCoverageAlerts.notCovered.modalDescriptionTwo'
                    )}
                </Body1>
            </Stack>
        </Modal>
    );
};
